import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';

import Extraction from './Extraction';
import Analysis from './Analysis';
import ConfirmInfoModal from './components/ConfirmInfoModal';

import {
  // ProcessingWrapper,
  // ProcessingContainer,
  HeaderSection,
  SectionTitle,
  SectionDescription,
  ActionButtons,
  DashboardButton,
  ContinueButton,
  ResultsPanel,
  TabsBar,
  Tab,
  TabContent,
} from './processing.styles';

const TABS = ['Extraction', 'Analysis'];

const Processing = ({ applicationId, onContinue, onDashboard }) => {
  const [activeTab, setActiveTab] = useState('Extraction');
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleConfirmed = () => {
    setShowConfirmModal(false);
    onContinue?.();
  };

  return (
    // <ProcessingWrapper>
    <>
      <HeaderSection>
        <div>
          <SectionTitle>Processing Result</SectionTitle>
          <SectionDescription>
            View extraction and analysis results from your documents
          </SectionDescription>
        </div>
        <ActionButtons>
          <DashboardButton onClick={onDashboard} type="button">
            Dashboard
          </DashboardButton>
          <ContinueButton type="button" onClick={() => setShowConfirmModal(true)}>
            Assessment <ArrowRight size={14} />
          </ContinueButton>
        </ActionButtons>
      </HeaderSection>

      <ResultsPanel>
        <TabsBar>
          {TABS.map((tab) => (
            <Tab
              key={tab}
              $active={activeTab === tab}
              onClick={() => setActiveTab(tab)}
              type="button"
            >
              {tab}
            </Tab>
          ))}
        </TabsBar>

        <TabContent>
          {activeTab === 'Extraction' && <Extraction listId={applicationId} />}
          {activeTab === 'Analysis' && <Analysis listId={applicationId} />}
        </TabContent>
      </ResultsPanel>

      {showConfirmModal && (
        <ConfirmInfoModal
          applicationId={applicationId}
          onClose={() => setShowConfirmModal(false)}
          onConfirmed={handleConfirmed}
        />
      )}
    </>
    // </ProcessingWrapper>
  );
};

export default Processing;
